import { enumRouteStatus } from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { RouteFormState } from '../types';

const initialState: RouteFormState = {
  description: '',
  status: enumRouteStatus.Planned,
  facilityGroupId: '',
  serviceIds: [],
};

export const $routeForm = atom<RouteFormState>(initialState);

export const $updateRouteForm = atom(
  null,
  (get, set, update: Partial<RouteFormState>) => {
    set($routeForm, { ...get($routeForm), ...update });
  },
);

export const $resetRouteForm = atom(null, (get, set) => {
  set($routeForm, initialState);
});
